import { render, staticRenderFns } from "./Parallex.vue?vue&type=template&id=fa3bdf04&"
import script from "./Parallex.vue?vue&type=script&lang=js&"
export * from "./Parallex.vue?vue&type=script&lang=js&"
import style0 from "./Parallex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports